export default __webpack_public_path__ + "28fb3614bbb1301fe9de3b55669d237d.png";